import { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import moment from 'moment/min/moment-with-locales';
import { Modal, OverlayTrigger, Tooltip, Row, Col } from 'react-bootstrap';
import { confirmAlert } from 'react-confirm-alert';

//components
import withLocalization from '~/hoc/withLocalization';
import withRemoveDialog from '~/hoc/withRemoveDialog';
import applicationRouter from '~/hoc/applicationRouter';
import GenericList from '~/components/GenericList/GenericList';
import GenericFilter from '../../../components/GenericList/GenericFilter.js';
import AbsencesTotals from './AbsencesTotals';
import AbsenceReportDownloadModal from './AbsenceReportDownloadModal';
import UserProfileLogo from '../../../components/UserProfileLogo/index.js';
import AbsenceVacationMassTimelogApproval from '../../../components/GenericModal/AbsenceVacationMassTimelogApproval.js';
import ImportFromExcelModal from '../../../components/GenericModal/ImportFromExcelModal.js';
import UserPromptModal from '../../../components/GenericModal/userPromptModal/index.js';

//elements
import Button from '../../../components/CustomButton/CustomButton.jsx';

//services
import agent from '~/library/agent';

//configs
import { API_ROOT } from '~/library/config';

//utils
import { statusMap } from '~/utils/normalStatuses';
import { shortDateFormat } from '~/utils/dateFormat';
import { absence_and_vacation_statuses, leave_type_status } from '~/utils/normalStatuses';
import customerFeature from '~/utils/customerFeature';
import { serverTimeFormat } from '~/library/core';
import { getIntegrationIconWithStatus, getIntegrationIconForExtraPayments } from '~/utils/integrationUtils';
import { minutesToTimeInput } from '~/utils/timeCalc';
import { DEFAULT_ABSENCE_TYPES } from '~/utils/constants';

//assets
import editIcon from '../../../assets/img/editing.svg';
import deleteIcon from '../../../assets/img/deleting.svg';
import cancelIcon from '../../../assets/img/InactiveUser.svg';
import CloseModalIcon from '../../../assets/img/CloseApproveModalIcon.svg';
import CompOffForm from './CompOffForm.js';

class AbsencesList extends Component {
    constructor(props) {
        super(props);
        const { page, isEdit, lastInteractedId } = this.props.router.location.state || {};
        if (lastInteractedId) {
            this.props.absenceStore.setLastInteractedId(lastInteractedId);
        }
        this.state = {
            accepting: null,
            acceptanceChanged: false,
            selected: null,
            start: '',
            end: '',
            dateRange: { start: moment(new Date()).startOf('month'), end: moment(new Date()) },
            all_members: '',
            users: '',
            types: '',
            page: page ? page : 0,
            isPageAddedOrEdited: isEdit ? isEdit : false,
            absenceTotalKey: new Date(),
            showCompOffForm: false,
            entity_id: null,
            userPromptModal: {
                source: '',
                header: '',
                showModal: false,
                sourceInfo: {},
                actionMethods: {}
            }
        };
        this.handlePageChange = this.handlePageChange.bind(this);
        this.confirmAbsenceCancellation = this.confirmAbsenceCancellation.bind(this);

        if (this.props?.router?.location?.state?.filters) {
            const { filters } = this.props.router.location.state;
            Object.keys(filters).forEach(key => {
                this.props.absenceStore.setFilter(key, filters[key]);
            });
            this.props.absenceStore.onFilter();
        }
        else if (!this.props.absenceStore?.appliedFilters?.status) {
            this.props.absenceStore.setFilter('status', '');
            this.props.absenceStore.onFilter();
        }
    }

    componentDidMount() {
        this.props.absenceStore.getAbsenceTotalsCounts();
        this.setState({
            start: this.state.dateRange.start.format('YYYY-MM-DD'),
            end: this.state.dateRange.end.format('YYYY-MM-DD'),
        });
        if (this.props.router.location.state?.redirectUserId)
            this.setState({ showCompOffForm: true });
    }

    handleTableButtonAction = (id, type, isSelfAbsence) => {
        this.props.absenceStore.setLastInteractedId(id);
        if (type === 'edit') {
            this.props.router.navigate(`/admin/absences/${id}`,
                { state: { absence: id, page: this.state.page, isEdit: this.state.isPageAddedOrEdited, lastInteractedId: id } });
        }
        else if (type === 'loadCompOff')
            this.setState({ showCompOffForm: true, entity_id: id })
        else if (type === 'cancel') {
            this.confirmAbsenceCancellation(id);
        }
        else if (type === 'remove') {
            return this.props.handleDelete(id, (id) => {
                return this.props.absenceStore.remove(id).then((res) => {
                    this.handlePageChange(this.state.page, true);
                    this.props.absenceStore.resetLastListLoadTime(new Date());
                    this.props.absenceStore.getAbsenceTotalsCounts();
                    if (res.sickLeaveResetToken) {
                        this.userSickLeaveResetPopUp(res.sickLeaveResetToken, isSelfAbsence);
                    }
                    return res;
                }).catch((err) => {
                    const userPrompt = err?.response?.body?.userPrompts?.[0];
                    if (userPrompt) {
                        this.setState({ userPromptModal: { ...userPrompt, actionMethods: { handleCloseUserPromptModal: this.handleCloseUserPromptModal } } });
                    }
                });
            });
        }
    };

    confirmAbsenceCancellation = (id) => {
        return confirmAlert({
            title: this.props.t("Absence Cancellation"),
            message: `${this.props.t("Are you sure you want to cancel this request, it cannot be changed later")}?`,
            buttons: [
                {
                    label: this.props.t('Yes'),
                    onClick: () => {
                        return this.props.absenceStore.cancelAbsence(id).then((res) => {
                            this.handlePageChange(this.state.page, true);
                            this.props.absenceStore.resetLastListLoadTime(new Date());
                            this.props.absenceStore.getAbsenceTotalsCounts();
                            this.setState({ absenceTotalKey: new Date() });
                            this.props.commonStore.addNotification(this.props.t(res.message), null, 'success')
                        }).catch((err) => {
                            const userPrompt = err?.response?.body?.userPrompts?.[0];
                            if (userPrompt) {
                                this.setState({ userPromptModal: { ...userPrompt, actionMethods: { handleCloseUserPromptModal: this.handleCloseUserPromptModal } } });
                                return;
                            }
                            this.props.commonStore.addNotification(this.props.t(err), null, 'error');
                        })
                    },
                },
                {
                    label: this.props.t('No'),
                    onClick: () => { },
                },
            ],
        });
    }

    userSickLeaveResetPopUp = (token, isSelfAbsence) => {
        confirmAlert({
            title: this.props.t("Reset employee's sick leave cycle?"),
            message: this.props.t("Do you wish to reset the employee's sick leave cycle as there are no more paid sick leave?"),
            buttons: [
                {
                    label: this.props.t('Yes'),
                    onClick: () => {
                        return this.props.userStore.resetUserSickLeaveStartDate(token).then((res2) => {
                            if (isSelfAbsence) {
                                this.props.userStore.pullUser().then((res3) => {
                                    this.props.commonStore.addNotification(this.props.t("Sick leave cycle reset successful"), null, 'success');
                                    return res3;
                                });
                            } else {
                                this.props.commonStore.addNotification(this.props.t("Sick leave cycle reset successful"), null, 'success');
                                return res2;
                            }

                        }).catch((err) => {
                            this.props.commonStore.addNotification(this.props.t(err), null, 'error');
                        })
                    },
                },
                {
                    label: this.props.t('No'),
                    onClick: () => { },
                },
            ],
        })
    }

    componentWillUnmount() {
        this.props.absenceStore.resetLastListLoadTime(null);
        this.props.absenceStore.clearLastInteractedId();
    }

    renderTableActionButtons = (id, full) => {
        const { t, commonStore, userStore } = this.props;
        const { config } = commonStore;
        const { user_type, id: user_id } = userStore.currentUser;
        const { status, absence_type } = full;
        const showStatus = status !== 'cancelled' && (user_type === 'pm' || user_type === 'admin') && customerFeature('allow_accepting');
        const allow = (user_type === 'pm' || user_type === 'admin') && customerFeature('pm_allow_editing_all');
        const showCommentModal = user_type === 'member' && (full.status === 'approved' || full.status === 'rejected')
        let statusText = status;
        if (!statusText) statusText = 'active';
        statusText = statusMap[statusText] || '';
        const isSelfAbsence = full.user_id === user_id;
        return (
            <div className="actions-center">
                {config?.integration_details?.product && full?.int_id && full?.int_has_child_failed && getIntegrationIconForExtraPayments(full.int_has_child_failed, t)}
                {
                    config?.integration_details?.product && full.status === 'approved' && (!full.int_id) && user_type !== 'member' && (<OverlayTrigger
                        placement="top"
                        key="payroll_history"
                        overlay={
                            <Tooltip>{`${t("View")} ${t("Payroll")} ${t("History")}`}</Tooltip>
                        }
                    >
                        <button
                            type="button"
                            className="p-0 ml-2 bg-transparent border-0"
                            title={`${t("View")} ${t("Payroll")} ${t("History")}`}
                            onClick={() => (showStatus ? this.handleAccept(id, full) : null)}
                        >
                            <i className="fa fa-history" style={{ color: '#888', fontSize: '1.5em' }} />
                        </button>
                    </OverlayTrigger>)
                }
                {getIntegrationIconWithStatus(config, full, t, false)}
                {customerFeature('allow_accepting') && (
                    <div
                        className={`status-block status-${status || 'active'} 
                        ${user_type === 'member' ? ' status-no-click-for-member' : ''}`}
                        onClick={() => (showCommentModal ? this.showApproveRejectCommentModal(full) : showStatus ? this.handleAccept(id, full) : null)}
                    >
                        {status === 'active' ||
                            !(full.status_changed_by && full.status_changed_on) ? (
                            <div className="text-capitalize">{t(statusText)}</div>
                        ) : (
                            <>
                                <div className="text-capitalize">
                                    {full.status_changed_by &&
                                        moment(new Date(full.status_changed_on)).format(serverTimeFormat(true))}
                                </div>
                                <div className="text-capitalize">
                                    {this.props.commonStore.getUsername(full.status_changed_by)}
                                </div>
                            </>
                        )}
                    </div>
                )}

                <OverlayTrigger
                    key="absence_edit"
                    placement="top"
                    overlay={
                        <Tooltip id="tooltip-top">
                            {t('Edit Absence')}
                        </Tooltip>
                    }
                >
                    <Button icon_sm fill
                        disabled={status !== 'active'}
                        onClick={() => absence_type === 'timebank' ? this.handleTableButtonAction(id, 'loadCompOff') : this.handleTableButtonAction(id, 'edit', isSelfAbsence)}>
                        <img src={editIcon} alt={'edit absence'} />
                    </Button>
                </OverlayTrigger>

                {user_type !== 'admin' &&
                    <OverlayTrigger
                        key="absence_cancel"
                        placement="top"
                        overlay={
                            <Tooltip id="tooltip-top">
                                {t('Cancel Absence')}
                            </Tooltip>
                        }
                    >
                        <Button icon_sm fill
                            disabled={!isSelfAbsence || status !== 'active'}
                            onClick={() => this.handleTableButtonAction(id, 'cancel', isSelfAbsence)}>
                            <img src={cancelIcon} alt={'cancel absence'} />
                        </Button>
                    </OverlayTrigger>
                }

                {allow &&
                    <OverlayTrigger
                        key="absence_delete"
                        placement="top"
                        overlay={
                            <Tooltip id="tooltip-top">
                                {t('Remove Absence')}
                            </Tooltip>
                        }
                    >
                        <Button icon_sm_delete fill
                            disabled={status === 'approved' && (!full.is_imported || user_type !== 'admin')}
                            onClick={() => this.handleTableButtonAction(id, 'remove', isSelfAbsence)}>
                            <img src={deleteIcon} alt="delete absence" />
                        </Button>
                    </OverlayTrigger>
                }
            </div>
        );
    };

    handleAccept(id, full) {
        this.props.absenceStore.setLastInteractedId(id);
        this.setState({
            accepting: {
                ids: [id],
                count: 1,
                entity: 'absence',
            },
        });
    }

    onMassAccept() {
        const ids = [];
        const { absenceStore, t, commonStore } = this.props;
        const { currentList } = absenceStore;
        if (!this.state.selected || (this.state.selected && !Object.values(this.state.selected).filter(Boolean).length > 0)) {
            commonStore.addNotification(t('Choose items'), null, 'error');
            return;
        }
        Object.keys(this.state.selected).forEach((id) => {
            if (this.state.selected[id]) ids.push(id);
        });

        const selectedItems = ids.map(id => currentList.rows.find(item => item.id === Number(id)));
        const allSameStatus = selectedItems.every(item => item.status === selectedItems[0].status);

        if (!allSameStatus) {
            commonStore.addNotification(t('Please select records with the same status to proceed with this action.'), null, 'warning');
            return;
        }

        this.setState({
            acceptanceChanged: false,
            accepting: {
                ids,
                count: ids.length,
                entity: 'absence',
            },
        });
    }

    handleHeaderTabs = (status) => {
        this.props.absenceStore.setFilter('status', status)
        this.props.absenceStore.onFilter();
    }

    isHeaderTabActive = (status) => {
        const { appliedFilters } = this.props.absenceStore;
        if (status === '') return !appliedFilters.status;
        return appliedFilters.status === status
    }

    renderAbsenceHeader = () => {
        const { t, commonStore, userStore } = this.props;
        const { user_type } = userStore.currentUser;
        const { page, isPageAddedOrEdited } = this.state;
        const { config } = commonStore;
        const { absenceStatusCounts } = this.props.absenceStore;

        const allowTimeBank = config.client.data.basicRules?.timeBankSettings?.allowTimeBank;
        const allowImportFromExcel = config.client.data.basicRules?.allowImportFromExcel;

        return (
            <Row className="align-content-center mt-2 gx-0">
                <Col xs={12} md={12} lg={5}>
                    <Row className="member_status__summary">
                        <Col xs={6} className="mt-2 mt-sm-0 justify-content-center">
                            <div
                                className={`highlighted ${this.isHeaderTabActive("active") ? 'active' : ""} cursor-pointer`}
                                role={'button'}
                                onClick={() => this.handleHeaderTabs("active")}
                            >
                                {t('Pending')}: {absenceStatusCounts.active ? absenceStatusCounts.active : '...'}
                            </div>
                        </Col>

                        <Col xs={6} className="mt-2 mt-sm-0 justify-content-center">
                            <div
                                className={`highlightedgreen ${this.isHeaderTabActive("approved") ? 'active' : ""} cursor-pointer`}
                                role={'button'}
                                onClick={() => this.handleHeaderTabs("approved")}
                            >
                                {t('Approved')}: {absenceStatusCounts.approved ? absenceStatusCounts.approved : '...'}
                            </div>
                        </Col>
                    </Row>
                </Col>
                <Col xs={12} lg={7} className="mt-2 mt-lg-0 text-start text-lg-end">
                    <div className="d-flex justify-content-lg-end flex-wrap gap-2">
                        {(user_type === 'admin') && allowImportFromExcel && (
                            <ImportFromExcelModal
                                importEntityType={'importUsedAbsence'}
                                entityName={t('Used Absence Leaves')}
                            />
                        )}

                        <Button fill wd onClick={() => this.handleAbsenceReportDownload()}>
                            <i className="fa fa-table fa-xl margin-right-10" />
                            {this.props.t('Download Excel')}
                        </Button>

                        {allowTimeBank &&
                            <Button fill wd onClick={() => this.setState({ showCompOffForm: true })}>
                                <i className="fa fa-plus-circle fa-xl margin-right-10" />
                                {this.props.t('Comp Off')}
                            </Button>
                        }

                        <Button fill wd onClick={() => this.props.onAdd(page, isPageAddedOrEdited)}>
                            <i className="fa fa-plus-circle fa-xl margin-right-10" />
                            {this.props.t('Add new')}
                        </Button>
                    </div>
                </Col>
            </Row>
        );
    }

    afterMassAccept() {
        this.handlePageChange(this.state.page, true);
        this.props.absenceStore.resetLastListLoadTime(new Date());
        this.props.absenceStore.getAbsenceTotalsCounts();
        this.setState({ accepting: null, acceptanceChanged: true });
    }

    handleAbsenceReportDownload = () => {
        this.setState({
            showDownloadReport: true,
        });
    };

    handleClosesDownloadReportModal = () => {
        this.setState({
            showDownloadReport: false,
            all_members: '',
            users: '',
            types: '',
        });
    };

    applyDownloadReportForm = () => {
        const { t, userStore } = this.props;
        let pmMembers = '';
        if (userStore.currentUser.user_type === 'pm' && userStore.currentUser?.Manages?.length) {
            pmMembers = userStore.currentUser.Manages.join(',');
        }
        if (this.state.users.length <= 0 && !this.state.all_members && this.props.userStore.currentUser.user_type !== 'member') {
            this.props.commonStore.addNotification(t('Choose users'), null, 'error');
            return;
        }

        if (!this.state.types) {
            this.props.commonStore.addNotification(t('Select') + ' ' + t('Absence types'), null, 'error');
            return;
        }

        let hydratedPayload = {
            start: this.state.start,
            end: this.state.end,
            all_members: this.state.all_members,
            users: this.props.userStore.currentUser.user_type === 'member' ? this.props.userStore.currentUser.id : this.state.users,
            types: this.state.types,
            authorization: this.props.commonStore.token,
            pmMembers
        };

        window.open(`${API_ROOT}/absences/report/main${agent.convertToGetParams(hydratedPayload)}`);
        this.handleClosesDownloadReportModal();
    };

    handleDownloadFormInputChange = (key, value) => {
        this.setState({ [key]: value });
    };

    getRowClassName = (row) => {
        if (row.id === this.props.absenceStore.lastInteractedId) return 'interacted-row';
        return '';
    }

    //handles generic list page change//
    handlePageChange = (page, isEdit) => {
        this.setState({ page, isPageAddedOrEdited: isEdit });
    };


    getAbsenceTypesSortingOptions = () => {
        const { config } = this.props.commonStore;
        const { t } = this.props;
        const { extendedRules = null, basicRules = null } = config?.client?.data;
        const absence_type = extendedRules?.absent_types ? [...extendedRules.absent_types] : [];
        if (!absence_type.length) return [];
        if (basicRules?.timeBankSettings?.allowTimeBank)
            absence_type.push({ code: 'timebank', name: 'Comp off' })
        const absenceTypesSortingOptions = [];
        absence_type.forEach((type) => {
            leave_type_status.forEach((status) => {
                if (type.code === 'timebank' && status.code === 'unpaid') return;
                absenceTypesSortingOptions.push({ value: `${type.code},${status.code}`, label: `${t(type.name)} - ${t(status.name)}` });
            })
        });
        absenceTypesSortingOptions.unshift({ value: '', label: t('All Leaves') });
        return absenceTypesSortingOptions;
    }

    handleCloseCompOffForm = () => {
        this.setState({ showCompOffForm: false, entity_id: null })
    }

    handleCloseUserPromptModal = () => {
        this.setState({ userPromptModal: { ...this.state.userPromptModal, showModal: false } })
    }

    showApproveRejectCommentModal = (full) => {
        const { commonStore } = this.props;
        const dateTimeRules = commonStore.getDateTimeRules();
        this.setState({
            userPromptModal: {
                source: 'adminPmComment',
                header: 'Comment',
                showModal: true,
                sourceInfo: {
                    status: full.status,
                    status_note: full.status_note,
                    status_changed_by: commonStore.getUsername(full.status_changed_by),
                    status_changed_on: shortDateFormat(full.status_changed_on, dateTimeRules)
                },
                actionMethods: { handleCloseUserPromptModal: this.handleCloseUserPromptModal }
            }
        });
    }

    render() {
        const { t, commonStore, absenceStore, userStore } = this.props;
        const { loading, filters, appliedFilters } = absenceStore;
        const { user_type, id: user_id } = userStore.currentUser;
        const { accepting, page, isPageAddedOrEdited, absenceTotalKey, userPromptModal } = this.state;
        const { config } = commonStore;
        const dateTimeRules = config.client && config.client.data
            && config.client.data.dateTimeRules ? config.client.data.dateTimeRules : false;

        return (
            <Fragment>
                <Modal size="lg" show={!!accepting} onHide={() => this.setState({ accepting: null })}>
                    <Modal.Header>
                        <Modal.Title className="w-100 text-center m-0">{this.props.t('Accept/reject')}</Modal.Title>
                        <img
                            src={CloseModalIcon}
                            alt='closeIcon'
                            className="cursor-pointer"
                            onClick={() => this.setState({ accepting: null })}
                        />
                    </Modal.Header>
                    <Modal.Body>
                        <AbsenceVacationMassTimelogApproval params={accepting} afterSave={() => this.afterMassAccept()} />
                    </Modal.Body>
                </Modal>
                {(user_type === 'member' || user_type === 'pm') && <AbsencesTotals
                    key={absenceTotalKey}
                    user_id={null}
                    for_date={moment()}
                    absenceStatus={null} />}
                <>
                    <GenericList
                        columns={[
                            user_type === 'member'
                                ? null
                                : {
                                    Header: '',
                                    id: 'user_image',
                                    accessor: ({ user_image }) => (
                                        <UserProfileLogo image_id={user_image ? user_image : false} />
                                    ),
                                    maxWidth: 40,
                                },
                            user_type === 'member'
                                ? null
                                : {
                                    Header: 'Member',
                                    id: 'first_name',
                                    isSortable: true,
                                    maxWidth: 110,
                                    accessor: ({ first_name, last_name }) => (
                                        <span>{first_name + ' ' + last_name}</span>
                                    ),
                                    textAlign: 'start',
                                },
                            {
                                Header: 'Project',
                                id: 'project_name',
                                maxWidth: 90,
                                isSortable: true,
                                textAlign: 'start',
                                accessor: ({ project_number, project_name }) => <span>
                                    {project_name ? ((project_number ? `${project_number} | ` : '') + project_name) : "-"}
                                </span>,
                            },
                            !config.client?.data?.basicRules?.allowWorkRelatedQueriesForAbsence
                                ? null :
                                {
                                    Header: 'Work Related',
                                    id: 'is_work_related_leave',
                                    maxWidth: 90,
                                    isSortable: true,
                                    accessor: ({ absence_type, data }) => {
                                        const allowWorkRelatedQueriesForAbsence = config.client?.data?.basicRules?.allowWorkRelatedQueriesForAbsence;
                                        const workRelatedAbsenceTypes = config?.client?.data?.basicRules?.workRelatedAbsenceTypes || [];
                                        const showWorkRelated = allowWorkRelatedQueriesForAbsence && workRelatedAbsenceTypes.includes(absence_type);
                                        return (<span>
                                            {showWorkRelated && data?.is_work_related_leave ? `${t('Yes')}` : '-'}
                                        </span>)
                                    },
                                },
                            {
                                Header: 'Type',
                                id: 'absence_type',
                                textAlign: 'start',
                                accessor: ({ absence_type, leave_type, is_imported }) => <span>{`${absence_type === 'timebank' ? t('Comp Off') : t(commonStore.getAbsenceTypeLabel(absence_type))} / ${is_imported || leave_type === DEFAULT_ABSENCE_TYPES.IMPORTED ? t('Imported') : leave_type === 'paid' ? t('Paid') : t('Not paid')}`}</span>
                            },
                            {
                                Header: 'Dates',
                                id: 'from',
                                isSortable: true,
                                maxWidth: 140,
                                accessor: ({ from, to }) => <span>{`${shortDateFormat(from, dateTimeRules)} | ${shortDateFormat(to, dateTimeRules)}`}</span>,
                            },
                            {
                                Header: 'Time',
                                id: 'time',
                                maxWidth: 80,
                                accessor: ({ start_time, end_time }) => {
                                    const startTimeObj = minutesToTimeInput(start_time, 'full');
                                    const endTimeObj = minutesToTimeInput(end_time, 'full');
                                    return <span>{typeof startTimeObj === 'object' ? startTimeObj.value : startTimeObj} - {typeof endTimeObj === 'object' ? endTimeObj.value : endTimeObj}</span>;
                                },
                            },
                            {
                                Header: 'Total days',
                                id: 'total_days',
                                maxWidth: 70,
                                accessor: ({ total_days, employement_grade, hours }) => {
                                    return <span>{`${employement_grade < 100 ? `${hours} ${t('H')} | ${total_days} ${t('D')}` : total_days}`}</span>
                                },
                            },
                            {
                                Header: 'Actions',
                                id: 'actions',
                                sortable: false,
                                minWidth: 190,
                                accessor: (full) => this.renderTableActionButtons(full.id, full),
                            },
                        ]}
                        header={
                            <GenericFilter
                                filters={filters}
                                setFilter={(name, value) => this.props.absenceStore.setFilter(name, value)}
                                onFilter={() => this.props.absenceStore.onFilter()}
                                hasSearch={user_type !== 'member'}
                                searchFilterPlaceholder={"Search by employee name"}
                                hasDateFilters={true}
                                hasStatusFilter={true}
                                statusOptions={absence_and_vacation_statuses}
                                hasCustomFilter={true}
                                customFilterOptions={this.getAbsenceTypesSortingOptions()}
                                customFilterName={{ value: 'absence_type', label: 'All Leaves' }}
                            />
                        }
                        getRowClassName={this.getRowClassName}
                        onRowClick={(row) => {
                            const current = this.props.absenceStore.lastInteractedId;
                            this.props.absenceStore.setLastInteractedId(current === row.id ? null : row.id);
                        }}
                        splitHeader={true}
                        tableHeader={this.props.t('Absents')}
                        filters={appliedFilters}
                        cutomCheckBoxClass={"top-position"}
                        loading={loading}
                        lastListLoadTime={this.props.absenceStore.lastListLoadTime}
                        forceReload={this.props.absenceStore.deleteSuccess || this.state.acceptanceChanged}
                        requestData={(params) => this.props.absenceStore.loadList(params)}
                        handlePageChange={(page, isEdit) => this.handlePageChange(page, isEdit)}
                        page={page} //new page props to maintain page from parent//
                        isPageAddedOrEdited={isPageAddedOrEdited} //to load same page after edit//
                    >
                        <>
                            {this.renderAbsenceHeader()}
                        </>
                    </GenericList>
                </>
                <Modal
                    className="modal fade"
                    show={this.state.showDownloadReport}
                    onHide={this.handleClosesDownloadReportModal}
                >
                    <Modal.Header>
                        <Modal.Title className="w-100 text-center m-0">{t('Download Absence Report')}</Modal.Title>
                        <img
                            src={CloseModalIcon}
                            alt='closeIcon'
                            className="cursor-pointer"
                            onClick={this.handleClosesDownloadReportModal}
                        />
                    </Modal.Header>
                    <Modal.Body className='absenceReportModalBody'>
                        <AbsenceReportDownloadModal
                            handleDownloadFormInputChange={this.handleDownloadFormInputChange}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.applyDownloadReportForm} className="btn-wd btn-fill">
                            {t('Download')}
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Modal
                    size="lg"
                    className="modal fade"
                    show={this.state.showCompOffForm}
                    onHide={this.handleCloseCompOffForm}
                >
                    <Modal.Header>
                        <Modal.Title className="w-100 text-center m-0">{t('Comp off leave')}</Modal.Title>
                        <img
                            src={CloseModalIcon}
                            alt='closeIcon'
                            className="cursor-pointer"
                            onClick={this.handleCloseCompOffForm}
                        />
                    </Modal.Header>
                    <Modal.Body className='absenceReportModalBody'>
                        <CompOffForm
                            user_id={user_id}
                            entity_id={this.state.entity_id}
                            handleCloseCompOffForm={this.handleCloseCompOffForm}
                        />
                    </Modal.Body>
                </Modal>
                <UserPromptModal
                    source={userPromptModal.source}
                    header={userPromptModal.header}
                    showModal={userPromptModal.showModal}
                    sourceInfo={userPromptModal.sourceInfo}
                    actionMethods={userPromptModal.actionMethods}
                />
            </Fragment>
        );
    }
}
export default inject(
    'absenceStore',
    'userStore',
    'commonStore'
)(applicationRouter(withLocalization(withRemoveDialog(observer(AbsencesList)))));
